export default {
      id: "ic_sort-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#ic_sort",
      toString: function () {
        return this.url;
      }
    }